/**
 * @name: knowledge
 * @description: 知识库
 * @author: qq2575896094
 * @time: 2024/8/6
 */

const prefix = '/onlinecs/knowledge'

/**
 * 新增知识库菜单
 * @type {string}
 */
export const addKnowledgeCatalogInfo = `${prefix}/addKnowledgeCatalogInfo`

/**
 * 获取所有知识库菜单
 * @type {string}
 */
export const getAllKnowledgeCatalogList = `${prefix}/getAllKnowledgeCatalogList`

/**
 * 获取单个知识库菜单
 * @type {number}
 */
export const getKnowledgeCatalogInfo = `${prefix}/getKnowledgeCatalogInfo`

/**
 * 修改单个知识库菜单
 * @type {string}
 */
export const modifyKnowledgeCatalog = `${prefix}/modifyKnowledgeCatalog`

/**
 * 删除单个知识库菜单
 * @type {string}
 */
export const removeKnowledgeCatalog = `${prefix}/removeKnowledgeCatalog`

/**
 * 获取知识库规则列表
 * @type {string}
 */
export const queryKnowledgeRulePage = `${prefix}/queryKnowledgeRulePage`

/**
 * 添加知识规则
 * @type {string}
 */
export const addKnowledgeRule = `${prefix}/addKnowledgeRule`

/**
 * 修改知识规则
 * @type {string}
 */
export const modifyKnowledgeRule = `${prefix}/modifyKnowledgeRule`

/**
 * 删除知识规则
 * @type {string}
 */
export const removeKnowledgeRule = `${prefix}/removeKnowledgeRule`

/**
 * 查询coze chat token
 * @type {string}
 */
export const queryCozeChatToken = `${prefix}/queryRobocommAuth`

/**
 * 基础问答下载场景模版
 * @type {string}
 */
export const downloadBasicSceneTemplate = `${prefix}/downloadKnowledgeModel`

/**
 * 批量导入基础问答
 * @type {string}
 */
export const batchImportKnowledge = `${prefix}/batchImportKnowledge`

/**
 * 批量删除基础问答
 * @type {string}
 */
export const batchRemoveKnowledgeRule = `${prefix}/batchRemoveKnowledgeRule`

/**
 * 批量开启或关闭基础问答
 * @type {string}
 */
export const batchModifyValidEnable = `${prefix}/batchModifyValidEnable`

/**
 * 批量修改分组
 * @type {string}
 */
export const batchModifyKnowledgeCatalog = `${prefix}/batchModifyKnowledgeCatalog`

/**
 * 下载基础问答
 * @type {string}
 */
export const batchDownloadKnowledge = `${prefix}/batchDownloadKnowledge`

/**
 * 获取问答时效列表
 * @type {string}
 */
export const queryKnowledgeTimeConfigPage = `${prefix}/queryKnowledgeTimeConfigPage`

/**
 * 新增问答时效
 * @type {string}
 */
export const addKnowledgeTimeConfig = `${prefix}/addKnowledgeTimeConfig`

/**
 * 编辑问答时效
 * @type {string}
 */
export const modifyKnowledgeTimeConfig = `${prefix}/modifyKnowledgeTimeConfig`

/**
 * 修改问答时效状态
 * @type {string}
 */
export const modifyKnowledgeTimeStatus = `${prefix}/modifyKnowledgeTimeStatus`

/**
 * 删除问答时效
 * @type {string}
 */
export const removeKnowledgeTimeConfig = `${prefix}/removeKnowledgeTimeConfig`
